import request from '@/router/axios';
const urlPrefix = process.env.VUE_APP_ACCOUNT_CLOUD_BASE_URL;

/**
 * 首页-工作进程
 * @param data
 *  year
 *  month
 *  perId
 */
export  function workCourse(year,month,perId) {
  return request({
    url: `/homePage/workCourse?year=${year}&month=${month}&perId=${perId}`,
    method: 'post'
  })
}

/**
 * 首页-节点状态数量（工作进程详情）
 * @param data
 *  year
 *  month
 *  cusId
 */
export  function workCountStatus(year,month,cusId) {
  return request({
    url: `/homePage/workCountStatus?year=${year}&month=${month}&cusId=${cusId}`,
    method: 'post'
  })
}

/**
 * 首页-代办提醒
 *  返回值
 *  one-进项税认证
 *  two-税金计提
 *  three-税金缴纳
 *  four-资产折旧/摊销
 * @param data
 *  year
 *  month
 */
export  function doRemind(year,month) {
  return request({
    url: `/homePage/doRemind?year=${year}&month=${month}`,
    method: 'post'
  })
}

/**
 * 首页-工作进程上边数据
 * @param data
 *  year
 *  month
 */
export  function messageAlert(year,month) {
  return request({
    url: `/homePage/alert?year=${year}&month=${month}`,
    method: 'post',
  })
}

/**
 * 获取日历数据
 * @param data
 *  zqScopeName：month
 *  zqStartDate 2014-09-28
 *  zqEndDate 2014-11-09
 * @returns {AxiosPromise}
 */
export function zqClendarInfo_ajaxGetCustomZqCalendar (data) {
  return request({
    url: '/accountCloud/zqCalendar/zqClendarInfo_ajaxGetCustomZqCalendar.action',
    method: 'post',
    data
  });
}
